$(document).ready(function() {
    $.fn.loader = function (accion) {
        let $btn = $(this)
        if (accion === 'show') {
            $btn.addClass('activo')
            $btn.attr('disabled', true)
        } else {
            $btn.removeClass('activo')
            $btn.attr('disabled', false)
        }
    }
});
